import { IInputErrorProps } from "./interface";
import styles from "./styles";

export function InputError({ text }: IInputErrorProps) {
  return <styles.InputErrorWrapper>{text}</styles.InputErrorWrapper>;
}
